const convertToHTML = (text: string) => {
	let HTML = ''
	const textList = text.split('\n')
	textList.forEach(t => {
		HTML += `<p>${t
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			// .replace(/"/g, "&quot;")
			// .replace(/'/g, "&#039;")
			.replace(/\*{1,2}(.*?)\*{1,2}/g, '<strong>$1</strong>')
			.replace(/_{1,2}(.*?)_{1,2}/g, '<em>$1</em>')
			.replace(/~{1,2}(.*?)~{1,2}/g, '<s>$1</s>')}</p>`
	})

	HTML = HTML.replaceAll('<p></p><p></p>', '<p><br></p>')

	if (HTML.substring(0, 11) === '<p><br></p>') {
		HTML = HTML.substring(11)
	}

	return HTML
}

export default convertToHTML
